export async function findPredictions(fields) {
  const predictions = await findAddressesWithGoogle(fields, fields.country?.isoCode || 'US');
  return predictions.map((prediction) => {
    return { description: prediction.description, placeId: prediction.place_id };
  });
}

export async function getPredictionAddress(prediction) {
  const placeDetails = await getDetailsOfPlace(prediction.placeId);
  if (placeDetails.length > 0) {
    return parsePlaceDetails(placeDetails);
  } else {
    return {};
  }
}

// TODO: When showcase moves to new version of placesService we can remove the newPlaceService param
export function parsePlaceDetails(placeDetails, newPlaceService = false, isCounty = false) {
  const shortValueKey = newPlaceService ? 'shortText' : 'short_name';
  const longValueKey = newPlaceService ? 'longText' : 'long_name';
  const parsedDetails = {
    address: [
      getAddressPart(placeDetails, 'street_number', longValueKey),
      getAddressPart(placeDetails, 'route', longValueKey)
    ].filter(value => value).join(' '),
    city: getAddressPart(placeDetails, 'locality', longValueKey),
    county: isCounty ? getCountyName(placeDetails) :
      !newPlaceService && getAddressPart(placeDetails, 'administrative_area_level_2', longValueKey)?.replace(/ County$/, ''),
    state: getAddressPart(placeDetails, 'administrative_area_level_1', shortValueKey),
    zip: getAddressPart(placeDetails, 'postal_code', longValueKey),
  };

  return Object.fromEntries(Object.entries(parsedDetails).filter(entry => entry[1]));
}

function getAddressPart(placeDetails, key, valueKey = 'long_name') {
  const part = placeDetails.find(detail => detail.types.includes(key));

  if (part) {
    return part[valueKey];
  }
}

function getCountyName(placeDetails) {
  // looks for existing county name first
  let part = placeDetails.find(detail => detail.types.includes('administrative_area_level_2'));

  // if no county name, fallback to city name for consolidated city-county
  if (!part) {
    part = placeDetails.find(detail => detail.types.includes('locality'));
  }

  return part ? part['longText'].replace(/ County$/, '') : null;
}

const getDetailsOfPlace = async (placeId) => {
  // we create a fake div since the PlaceService requires a div to be passed in. we do not need to add it to the DOM
  const fakeDiv = document.createElement('div');
  const service = new google.maps.places.PlacesService(fakeDiv);
  const request = {
    placeId: placeId,
    fields: ['address_components']
  };

  try {
    return await new Promise((resolve, reject) => {
      service.getDetails(request, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(place.address_components);
        } else {
          reject(status);
        }
      });
    });
  } catch {
    return {};
  }
};

const findAddressesWithGoogle = async (formFields, countryIsoCode) => {
  const sessionToken = new google.maps.places.AutocompleteSessionToken();

  try {
    const placesLib = await google.maps.importLibrary('places');
    const AutocompleteSuggestion = placesLib.AutocompleteSuggestion;

    const request = {
      input: buildAddress(formFields),
      sessionToken: sessionToken,
      includedRegionCodes: [countryIsoCode],
      language: 'en-US',
      region: countryIsoCode
    };

    const result = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
    const suggestions = result?.suggestions || [];

    return suggestions.map((suggestion) => {
      const place = suggestion.placePrediction || {};
      return {
        description: (place.text && place.text.text) || '',
        place_id: place.placeId
      };
    });
  } catch {
    return [];
  }
};

const buildAddress = (formFields) => {
  let fullAddress = `${formFields.address}`;
  if (formFields.city) {
    fullAddress += `, ${formFields.city}`;
  }

  if (formFields.state) {
    fullAddress += `, ${formFields.state}`;
  }

  if (formFields.zip) {
    fullAddress += ` ${formFields.zip}`;
  }

  return fullAddress;
};
